<template>
  <section class="team-wrapper" id="gltd">
    <div class="section">
      <div class="desc-title"><span class="active">{{ $t('teamSection.title') }}</span><span> / {{ $t('teamSection.subTitle') }}</span></div>

      <div class="index-swiper-wrapper">
        <swiper ref="mainSwiperRef" :options="mainOptions" class="index-swiper">
          <swiper-slide v-for="(item, idx) in team" :key="`main-${idx}`">
            <div class="slide-wrap">
              <div class="left-slide">
                <img :src="item.image" :alt="$t(item.nameKey)" />
              </div>
              <div class="right-slide">
                <div class="title-row">
                  <span class="name">{{ $t(item.nameKey) }}</span>
                  <span class="position">{{ $t(item.positionKey) }}</span>
                </div>
                <div class="dot"><img src="@/static/image/about-team6.png" alt="dot" /></div>
                <div class="desc" v-html="$t(item.descKey)"></div>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="pagination">
          <span class="btn pre" @click="prevMain">
            <img src="@/static/image/about-y-arr1.png" alt="pre" />
          </span>
          <span class="btn next" @click="nextMain">
            <img src="@/static/image/about-y-arr2.png" alt="next" />
          </span>
        </div>
      </div>

      <swiper ref="thumbSwiperRef" :options="thumbOptions" class="team-list-swiper team-list">
        <swiper-slide
          v-for="(item, idx) in team"
          :key="`thumb-${idx}`"
          class="experts"
          :class="{ active: idx === activeIndex }"
        >
          <button class="thumb-btn" type="button" @click.stop="goTo(idx)">
            <img :src="item.thumb" :alt="$t(item.nameKey)" />
          </button>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TeamSection',
  data() {
    return {
      activeIndex: 0,
      mainOptions: {
        loop: false,
        autoplay: 3000,
        autoplayDisableOnInteraction: false,
        onSlideChangeEnd: swiper => {
          this.activeIndex = swiper.activeIndex || 0
          this.syncThumb(this.activeIndex)
        }
      },
      thumbOptions: {
        slidesPerView: 5,
        spaceBetween: 6
      },
      team: [
        {
          nameKey: 'teamSection.members.m1.name',
          positionKey: 'teamSection.members.m1.position',
          descKey: 'teamSection.members.m1.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/1.png',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/1-1.png'
        },
        {
          nameKey: 'teamSection.members.m2.name',
          positionKey: 'teamSection.members.m2.position',
          descKey: 'teamSection.members.m2.desc',
          image: 'https://ddkj-yg.oss-cn-beijing.aliyuncs.com/2025/07/03/153ec4307ac14543b9bebd38b5d25819李双双.jpg',
          thumb: 'https://ddkj-yg.oss-cn-beijing.aliyuncs.com/2025/07/03/bc546672b415416fa697c4148b1d7219李双双.jpg'
        },
        {
          nameKey: 'teamSection.members.m3.name',
          positionKey: 'teamSection.members.m3.position',
          descKey: 'teamSection.members.m3.desc',
          image: 'https://ddkj-yg.oss-cn-beijing.aliyuncs.com/2025/07/03/8bea9475e264405893d6b502e297b674图片2.png',
          thumb: 'https://ddkj-yg.oss-cn-beijing.aliyuncs.com/2025/07/03/e1e47e26bb7641e9b35ca19df9d03e4d严寒.jpg'
        },
        {
          nameKey: 'teamSection.members.m4.name',
          positionKey: 'teamSection.members.m4.position',
          descKey: 'teamSection.members.m4.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/4.png',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/4-1.png'
        },
        {
          nameKey: 'teamSection.members.m5.name',
          positionKey: 'teamSection.members.m5.position',
          descKey: 'teamSection.members.m5.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/24b15df2-9c2f-4461-9eac-4f66c31ecf6f.jpg',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/7debd20c-9893-4f96-bc77-ccb5b2d9e01d.jpg'
        },
        {
          nameKey: 'teamSection.members.m6.name',
          positionKey: 'teamSection.members.m6.position',
          descKey: 'teamSection.members.m6.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/7.png',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/7-1.png'
        },
        {
          nameKey: 'teamSection.members.m7.name',
          positionKey: 'teamSection.members.m7.position',
          descKey: 'teamSection.members.m7.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/3.png',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/3-1.png'
        },
        {
          nameKey: 'teamSection.members.m8.name',
          positionKey: 'teamSection.members.m8.position',
          descKey: 'teamSection.members.m8.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/8.png',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/8-1.png'
        },
        {
          nameKey: 'teamSection.members.m9.name',
          positionKey: 'teamSection.members.m9.position',
          descKey: 'teamSection.members.m9.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/2.png',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/2-1.png'
        },
        {
          nameKey: 'teamSection.members.m10.name',
          positionKey: 'teamSection.members.m10.position',
          descKey: 'teamSection.members.m10.desc',
          image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/6.png',
          thumb: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/6-1.png'
        }
      ]
    }
  },
  computed: {
    mainSwiper() {
      const ref = this.$refs.mainSwiperRef
      return ref && (ref.$swiper || ref.swiper)
    },
    thumbSwiper() {
      const ref = this.$refs.thumbSwiperRef
      return ref && (ref.$swiper || ref.swiper)
    }
  },
  methods: {
    prevMain() {
      if (!this.mainSwiper) return
      if (typeof this.mainSwiper.slidePrev === 'function') this.mainSwiper.slidePrev()
      else if (typeof this.mainSwiper.swipePrev === 'function') this.mainSwiper.swipePrev()
    },
    nextMain() {
      if (!this.mainSwiper) return
      if (typeof this.mainSwiper.slideNext === 'function') this.mainSwiper.slideNext()
      else if (typeof this.mainSwiper.swipeNext === 'function') this.mainSwiper.swipeNext()
    },
    goTo(index) {
      if (this.mainSwiper) {
        if (typeof this.mainSwiper.slideToLoop === 'function') {
          this.mainSwiper.slideToLoop(index)
        } else {
          this.mainSwiper.slideTo(index)
        }
      }
      this.activeIndex = index
      this.syncThumb(index)
    },
    syncThumb(index) {
      if (!this.thumbSwiper) return
      const start = this.thumbSwiper.activeIndex || 0
      const end = start + 4
      if (index < start || index > end) {
        const target = Math.max(index - 2, 0)
        if (typeof this.thumbSwiper.slideTo === 'function') this.thumbSwiper.slideTo(target)
        else if (typeof this.thumbSwiper.swipeTo === 'function') this.thumbSwiper.swipeTo(target)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.team-wrapper { padding: 80px 0; background: #f5f9ff; }
.section { width: 1200px; margin: 0 auto; }
.desc-title { text-align: center; color: #929292; font-size: 16px; }
.desc-title .active { color: #1c51a3; font-size: 28px; }
.index-swiper-wrapper { position: relative; }
.index-swiper { margin-top: 48px; height: 500px; }
.slide-wrap { display: flex; }
.left-slide { width: 400px; height: 500px; margin-right: 42px; }
.left-slide img { width: 100%; height: 100%; object-fit: cover; }
.right-slide { width: 756px; padding-top: 80px; color: #333; text-align: left;}
.title-row { color: #1c51a3; }
.name { font-size: 30px; font-weight: 600; }
.position { margin-left: 12px; font-size: 16px; }
.dot img { width: 62px; height: 52px; margin-top: 26px; }
.desc { margin-top: 18px; font-size: 14px; line-height: 26px; color: #666; }
.pagination { position: absolute; right: 0; bottom: 24px; z-index: 9; }
.pagination .btn { display: inline-block; width: 78px; height: 78px; cursor: pointer; }
.pagination .btn.pre { margin-right: 42px; }
.pagination .btn img { width: 78px; height: 78px; }
.team-list { margin-top: 32px; height: 234px; }
.team-list .experts { width: 234px !important; height: 234px !important; opacity: 0.8; cursor: pointer; transition: all .2s ease; }
.team-list .experts.active { opacity: 1; box-shadow: inset 0 0 0 3px #1c51a3; }
.team-list .experts .thumb-btn {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.team-list .experts img { width: 100%; height: 100%; object-fit: cover; display: block; }
</style>
